import React, { Fragment } from "react";
import Header from "../Layout/Header";
import Message from "../Layout/Message";
import Navbar from "./Navbar";
import NavbarNew from "./NavbarNew";
let UserInterface = ({ noNav = false, children }) => (
  <div className="wrapperDiv">
    {/* {!noNav && <Navbar />} */}
    {!noNav && <NavbarNew />}
    <Message />
    <Fragment>
      <Header />
      <div id="content" className="no-sidebar">
        {children}
      </div>
    </Fragment>
  </div>
);
export default UserInterface;
